// extracted by mini-css-extract-plugin
export default {"impact":"ImportConfirmModal_impact__pEiDX"};